var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataCatalogue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 136,
    viewBox: "0 0 272 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2504_236892)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.527 89.3232C209.602 89.5749 215.101 93.4458 215.101 93.4458L272.456 138H179.209C179.209 138 120.336 93.5717 118.574 92.2971C115.781 90.283 110.242 89.2603 110.242 89.2603L112.862 89.3232H204.527Z",
    fill: "white",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82935 -17C10.0526 -17.001 11.2639 -16.7607 12.3941 -16.2929C13.5244 -15.825 14.5511 -15.1388 15.4157 -14.2735C16.2803 -13.4082 16.9657 -12.3808 17.4326 -11.2502C17.8995 -10.1196 18.1388 -8.90799 18.1367 -7.68478V106.718C18.1397 108.227 18.5042 109.713 19.1998 111.052C19.8954 112.39 20.9017 113.543 22.1346 114.413C23.3674 115.283 24.7907 115.845 26.2853 116.051C27.7799 116.258 29.3023 116.103 30.7248 115.6L101.321 90.5262C105.023 89.2075 109.028 88.9836 112.854 89.8811V-7.68478C112.854 -10.1532 111.874 -12.5206 110.128 -14.2661C108.383 -16.0115 106.016 -16.9921 103.547 -16.9921L8.82935 -17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6504 93.6108L30.7325 115.601C29.31 116.104 27.7877 116.258 26.2931 116.052C24.7984 115.845 23.3751 115.283 22.1423 114.414C20.9095 113.544 19.9031 112.391 19.2075 111.052C18.5119 109.713 18.1474 108.227 18.1444 106.718V93.6108H92.6504Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M92.6504 93.6108L30.7325 115.601C29.31 116.104 27.7877 116.258 26.2931 116.052C24.7984 115.845 23.3751 115.283 22.1423 114.414C20.9095 113.544 19.9031 112.391 19.2075 111.052C18.5119 109.713 18.1474 108.227 18.1444 106.718V93.6108H92.6504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82934 -17C10.0526 -17.001 11.2639 -16.7607 12.3941 -16.2929C13.5244 -15.825 14.5511 -15.1388 15.4157 -14.2735C16.2803 -13.4082 16.9657 -12.3808 17.4326 -11.2502C17.8995 -10.1196 18.1388 -8.90799 18.1367 -7.68478V106.718C18.1397 108.227 18.5042 109.713 19.1998 111.052C19.8954 112.39 20.9018 113.543 22.1346 114.413C23.3674 115.283 24.7907 115.845 26.2853 116.051C27.7799 116.258 29.3023 116.103 30.7248 115.6L101.321 90.5262C105.023 89.2075 109.028 88.9835 112.854 89.8811V-7.68478C112.854 -10.1532 111.874 -12.5206 110.128 -14.2661C108.383 -16.0115 106.016 -16.9921 103.547 -16.9921L8.82934 -17Z",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.85 89.323H112.862",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5616 116.16H122.287C123.361 116.155 124.425 115.966 125.434 115.601L141.791 109.85L121.453 94.1936C118.707 91.879 115.404 90.3229 111.871 89.6798C108.338 89.0367 104.698 89.3288 101.312 90.5273L30.7165 115.601C29.7046 115.967 28.6375 116.156 27.5616 116.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5623 116.159H122.288C123.361 116.155 124.426 115.966 125.435 115.601L142.807 109.543L121.47 94.1931C118.724 91.8785 115.42 90.3225 111.887 89.6793C108.354 89.0362 104.714 89.3283 101.329 90.5268L30.733 115.601C29.7161 115.968 28.6435 116.157 27.5623 116.159Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.5623 116.159H122.288C123.361 116.155 124.426 115.966 125.435 115.601L142.807 109.543L121.47 94.1931C118.724 91.8785 115.42 90.3225 111.887 89.6793C108.354 89.0362 104.714 89.3283 101.329 90.5268L30.733 115.601C29.7161 115.968 28.6435 116.157 27.5623 116.159Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5616 116.16H122.287C123.361 116.155 124.425 115.966 125.434 115.601L141.791 109.85L121.453 94.1936C118.707 91.879 115.404 90.3229 111.871 89.6798C108.338 89.0367 104.698 89.3288 101.312 90.5273L30.7165 115.601C29.7046 115.967 28.6375 116.156 27.5616 116.16V116.16Z",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.289 116.16H122.492",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3824 116.16H27.562",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25193 -14.2699C3.11305 -15.1376 4.13783 -15.8257 5.26688 -16.2943C6.39593 -16.763 7.6068 -17.0028 8.82924 -17C18.5221 -17 18.1366 -7.69262 18.1366 -7.69262V9.82061H-0.478121V-7.68476C-0.481129 -8.9084 -0.241373 -10.1205 0.227243 -11.2508C0.69586 -12.3812 1.38403 -13.4073 2.25193 -14.2699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M104.168 -0.965223V-0.799998V3.17313V3.33835V7.31148V7.4767V11.442V11.6072V15.5803V15.7455V19.7186V19.8839V23.8491V24.0144V27.9875V28.1527V32.1258V32.291V36.2563V36.4215V40.3946V40.5599V44.6982H95.1758V40.5599V40.3946V36.4215V36.2563V32.291V32.1258V28.1527V27.9875V24.0144V23.8491V19.8839V19.7186V15.7455V15.5803V11.6072V11.442V7.4767V7.31148V3.33835V3.17313V-0.799998V-0.965223V-5.0957H104.168V-0.965223Z",
    fill: "#666666"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.1758 -0.965088H104.168V3.33848H95.1758V-0.965088Z",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1758 3.17383H104.168V7.4774H95.1758V3.17383Z",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1758 7.31128H104.168V11.6148H95.1758V7.31128Z",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1758 11.4421H104.168V15.7457H95.1758V11.4421Z",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1758 15.5806H104.168V19.8841H95.1758V15.5806Z",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1758 19.719H104.168V24.0226H95.1758V19.719Z",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1758 23.8484H104.168V28.152H95.1758V23.8484Z",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1758 27.9878H104.168V32.2914H95.1758V27.9878Z",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1758 32.126H104.168V36.4295H95.1758V32.126Z",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1758 36.2566H104.168V40.5602H95.1758V36.2566Z",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1758 40.3953H104.168V44.6988H95.1758V40.3953Z",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4698 -0.799805H95.1758V44.6906H24.4698V-0.799805Z",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1836 -0.799805V44.6827",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3794 -0.799805V44.6827",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5757 -0.799805V44.6827",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.772 -0.799805V44.6827",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9756 -0.799805V44.6827",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1719 -0.799805V44.6827",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3682 -0.799805V44.6827",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1758 3.33813H24.517",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1758 7.46069H24.517",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1758 11.5833H24.517",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1758 15.7058H24.517",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1758 19.8291H24.517",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1758 23.9434H24.517",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1758 28.0654H24.517",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1758 32.1885H24.517",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1758 36.311H24.517",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1758 40.4338H24.517",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.25 100.4H216.054L210.822 96.427H135.018L140.25 100.4Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.17 132.295H258.027L210.821 96.427H208.957L256.17 132.295Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.952 113.068H232.749L226.824 108.63H151.028L156.952 113.068Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.467 132.476H258.271L210.822 96.427H135.017L182.467 132.476Z",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.009 96.5615L250.254 132.453",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.393 96.5615L242.638 132.453",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.785 96.5615L235.03 132.453",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.169 96.5615L227.414 132.453",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.554 96.5615L219.798 132.453",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.938 96.5615L212.19 132.453",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.33 96.5615L204.575 132.453",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.714 96.5615L196.959 132.453",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.098 96.5615L189.351 132.453",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.695 104.027H145.119",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.73 108.615H151.154",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.765 113.201H157.189",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.799 117.78H163.223",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.833 122.367H169.257",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.867 126.954H175.291",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.344 48.1685H104.239V51.1031H24.344V48.1685Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.28 48.1685H104.239V85.9643H102.28V48.1685Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.344 48.1685H104.239V86.161H24.344V48.1685Z",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8208 48.3086V86.1359",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7959 48.3086V86.1359",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.771 48.3086V86.1359",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7461 48.3086V86.1359",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7217 48.3086V86.1359",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6963 48.3086V86.1359",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6714 48.3086V86.1359",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6543 48.3086V86.1359",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6299 48.3086V86.1359",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.105 56.1763H24.4462",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.105 61.0154H24.4462",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.105 65.8459H24.4462",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.105 70.6772H24.4462",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.105 75.5076H24.4462",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.105 80.3379H24.4462",
    stroke: "#BDBDBD",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7951 72.4155H54.123V80.1887H50.7951V72.4155Z",
    fill: "#CED7F4",
    stroke: "#CED7F4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4606 67.7578H48.7886V80.1965H45.4606V67.7578Z",
    fill: "#CED7F4",
    stroke: "#CED7F4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1344 59.9851H43.4624V80.1969H40.1344V59.9851Z",
    fill: "#CED7F4",
    stroke: "#CED7F4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7999 67.5298H38.1279V80.1887H34.7999V67.5298Z",
    fill: "#CED7F4",
    stroke: "#CED7F4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4738 59.9851H32.8018V80.1969H29.4738V59.9851Z",
    fill: "#CED7F4",
    stroke: "#CED7F4",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0584 70.8491V80.0856C87.5081 80.0856 89.8574 79.1125 91.5896 77.3803C93.3218 75.6481 94.2949 73.2988 94.2949 70.8491C94.2949 68.3994 93.3218 66.0501 91.5896 64.3179C89.8574 62.5857 87.5081 61.6125 85.0584 61.6125V70.8491Z",
    fill: "#CED7F4",
    stroke: "#BDBDBD",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0581 70.8506L76.2779 67.9946C75.8999 69.1486 75.7533 70.3659 75.8466 71.5766C75.9399 72.7873 76.2712 73.9678 76.8216 75.0502C77.3719 76.1327 78.1305 77.0959 79.0538 77.8846C79.9771 78.6733 81.047 79.2721 82.2022 79.6465C83.1226 79.9547 84.0875 80.1089 85.0581 80.1028V70.8506Z",
    fill: "white",
    stroke: "#BDBDBD",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0581 70.8497V61.6132C83.1029 61.5905 81.1925 62.1991 79.6107 63.3486C78.0289 64.4981 76.8601 66.1271 76.2779 67.9938L85.0581 70.8497Z",
    fill: "#9FA6CB",
    stroke: "#BDBDBD",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2504_236892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 272,
    height: 136,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataCatalogue);
export default __webpack_public_path__ + "static/media/data-catalogue.07626171.svg";
export { ForwardRef as ReactComponent };